module.exports = __webpack_public_path__ + "img/tu-2_28.77e5c2d8.jpg";